import { useContext, useState } from 'react';
import DataTable from '../DataTable';
import { Select } from '../Input/Input';
import { PreferentialTooltip, PreferentialTooltipClick } from '../Newload/ProductInfo/Tooltips';
import { IpaffsContext } from './IpaffsModal';
import IpaffsModaltable from './IpaffsModalTable';

const IpaffsModalDetailedView = () => {
  const { handleSetItemsSelectedValue, ipaffsCategories, data } = useContext(IpaffsContext);
  const [persist, setPersist] = useState({});

  return (
    <IpaffsModaltable data={data?.data ?? []} persist={persist} setPersist={setPersist}>
      <DataTable.Column colKey="hsCode" key="hsCode" header="HS Code" />
      <DataTable.Column colKey={'origin'} key={'origin'} header="Origin" />
      <DataTable.Column colKey={'description'} key={'description'} header="Description" />
      <DataTable.Column
        colKey="riskCategory"
        header="Risk Category"
        tooltip={
          <PreferentialTooltip>
            <p>This is the list of categories which can apply to this HS Code. This does not include FFNAO.</p>
          </PreferentialTooltip>
        }
      >
        {(item) => {
          return (
            <div className="ipaffs-modal-table-risk-category">
              {item.riskCategory}
              {item?.catDesc && (
                <PreferentialTooltipClick>
                  <p>{item?.catDesc}</p>
                </PreferentialTooltipClick>
              )}
            </div>
          );
        }}
      </DataTable.Column>
      <DataTable.Column
        colKey="confirmedCategory"
        header="Confirmed Category"
        style={{ height: '1px', padding: 0 }}
        tooltip={
          <PreferentialTooltip>
            <p>Select the Risk Category which applies to the HS Code.</p>
          </PreferentialTooltip>
        }
      >
        {(item) => {
          return (
            <Select
              hideLabel={true}
              name={`${item.hsCode} category`}
              data={ipaffsCategories?.[item.id]?.value ?? 0}
              options={item?.riskCategoryOptions ?? []}
              required={true}
              disabled={false}
              stopSetDefault={true}
              setData={(value) => handleSetItemsSelectedValue(item, value)}
            />
          );
        }}
      </DataTable.Column>
      <DataTable.Column colKey={'grossWeight'} key={'grossWeight'} header="Gross Weight (Kg)" />
    </IpaffsModaltable>
  );
};

export default IpaffsModalDetailedView;
